var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUpSolid = function SvgChevronUpSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.688 1.594 20.094l.687.718 3.907 3.907.718.687L16 16.313l9.094 9.093.718-.687 3.907-3.907.687-.718Zm0 2.843 11.563 11.594-2.438 2.438-8.406-8.375L16 13.5l-.719.688-8.406 8.375-2.437-2.438Z"
  })));
};
export default SvgChevronUpSolid;